const overlay = document.querySelector("#view-overlay");

let lastDrawer = null;

overlay.addEventListener("click", () => {
    if (!lastDrawer) return;
    close(lastDrawer);
});

window.addEventListener("open-drawer", (e) => {
    if (lastDrawer) {
        close(lastDrawer);
    }
    open(e.elements);
});

window.addEventListener("close-drawer", (e) => {
    close(e.elements);
});

function open([drawer, toggler]) {
    window.dispatchEvent(new Event("lock-header"));
    lockScroll();
    const header = document.querySelector("header > nav");
    const headerBB = header.getBoundingClientRect();
    const top = headerBB.bottom;
    drawer.style.top = top;
    drawer.style.height = `calc(100% - ${top}px)`;
    drawer.classList.add("open");
    toggler?.classList.add("open");
    overlay.classList.add("show");
    lastDrawer = [drawer, toggler];
}

function close() {
    window.dispatchEvent(new Event("unlock-header"));
    unlockScroll();
    lastDrawer.at(0).classList.remove("open");
    lastDrawer.at(1)?.classList.remove("open");
    overlay.classList.remove("show");
    lastDrawer = null;
    setTimeout(() => {
        window.dispatchEvent(new Event("drawer-closed"));
    }, 350);
}

function scrollLock(e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
}

function lockScroll() {
    console.trace("lock scroll");
    document.body.style.overflow = "hidden";
    let e = document.querySelector("main");
    while (e) {
        e.addEventListener("touchmove", scrollLock);
        e.addEventListener("scroll", scrollLock);
        e.addEventListener("wheel", scrollLock);
        e = e.parentElement;
    }
}
function unlockScroll() {
    document.body.style.overflow = null;
    let e = document.querySelector("main");
    while (e) {
        e.removeEventListener("touchmove", scrollLock);
        e.removeEventListener("scroll", scrollLock);
        e.removeEventListener("wheel", scrollLock);
        e = e.parentElement;
    }
}
const pagination = document.querySelector(".pagination");
const currentPage = parseInt(
    pagination?.querySelector(".page.current")?.innerText,
);

const productsGrid = document.querySelector(".products-grid");

const productsCount = parseInt(pagination?.getAttribute("data-count"));
const productsPerPage = parseInt(pagination?.getAttribute("data-per-page"));
let productsPages = [];

if (
    productsCount &&
    !isNaN(productsCount) &&
    currentPage &&
    !isNaN(currentPage) &&
    productsPerPage &&
    !isNaN(productsPerPage)
) {
    const pagesCount = Math.ceil(productsCount / productsPerPage);
    productsPages = new Array(pagesCount)
        .fill(null)
        .map((_, i) => {
            const pageIndex = i + 1;
            return pageIndex === currentPage ? null : pageIndex;
        })
        .filter(Boolean);

    window.addEventListener("scroll", checkIfProductsLoadNeeded);
    checkIfProductsLoadNeeded();
}

window.addEventListener("view-shift", checkIfProductsLoadNeeded);

function checkIfProductsLoadNeeded() {
    if (!pagination || productsPages.length === 0) {
        window.removeEventListener("scroll", checkIfProductsLoadNeeded);
        return;
    }

    const lastProduct = Array.from(
        document.querySelectorAll(".product-card"),
    ).at(-1);
    const lastProductBB = lastProduct.getBoundingClientRect();

    if (lastProductBB.top < window.innerHeight * 1.5) {
        loadNextPage();
    }
}

let currentPageLoading = null;
const parser = new DOMParser();

async function loadNextPage() {
    if (currentPageLoading) return;
    currentPageLoading = productsPages.shift();
    if (!currentPageLoading) return;

    const url = new URL(window.location.href);
    url.searchParams.set("page", currentPageLoading);
    const response = await fetch(url);
    const pageText = await response.text();
    const html = parser.parseFromString(pageText, "text/html");
    const products = html.querySelectorAll(".product-card");
    productsGrid.append(...Array.from(products));
    currentPageLoading = null;
    checkIfProductsLoadNeeded();
}

function googleTranslateElementInit() {
    document.documentElement.setAttribute("translate", "yes");
    new google.translate.TranslateElement(
        { pageLanguage: "en" },
        "translate_element",
    );
    setTimeout(checkForButtonLabel, 1000);
}

if (window.translate_element) {
    window.translate_element.onclick = () => {
        const switcher = document.querySelector(".goog-te-combo");
        switcher.value = document.documentElement.classList.contains(
            "translated-ltr",
        )
            ? "en"
            : "fr-CA";
        switcher.dispatchEvent(new Event("change"));

        if (switcher.value === "en") {
            const iframe = document.querySelector("body iframe.skiptranslate");
            const innerDoc =
                iframe.contentDocument || iframe.contentWindow.document;
            const restoreButton = innerDoc.querySelector(
                "td:last-child a[href='#']",
            );
            restoreButton.click();
            window.location.reload();
        }

        setTimeout(checkForButtonLabel, 1000);
    };
}

function checkForButtonLabel() {
    const button = document.querySelector(
        "#translate_element > span:first-child",
    );
    if (document.documentElement.classList.contains("translated-ltr")) {
        button.innerText = "EN";
    } else {
        button.innerText = "FR";
    }
}

const desktopLocation = document.querySelector("#translate-location-desktop");
const mobileLocation = document.querySelector("#translate-location-mobile");

function moveLangSwitcher() {
    const button = document.querySelector("#translate_element");
    if(!button) return;
    if (window.innerWidth < 768) {
        mobileLocation.append(button);
    } else {
        desktopLocation.append(button);
    }
}
moveLangSwitcher();

window.addEventListener("resize", () => {
    moveLangSwitcher();
});

const banner = document.querySelector("header > .banner");
const header = document.querySelector("header > nav");

const bannerHeight = banner.getBoundingClientRect().height;

let locked = false;
function fixHeader() {
    if (window.scrollY < bannerHeight) {
        const bottom = banner.getBoundingClientRect().bottom;
        header.setAttribute("style", `top:${bottom}px !important`);
    }
    header.classList.add("fixed");
}

window.addEventListener("lock-header", () => {
    fixHeader();
    locked = true;
});
window.addEventListener("unlock-header", () => {
    locked = false;
});

let lastScroll = window.scrollY;
window.addEventListener("scroll", () => {
    const headerBB = header.getBoundingClientRect();
    if (headerBB.bottom < 0) {
        header.style.top = window.scrollY - headerBB.height;
    }

    if (window.scrollY - lastScroll < 0 && window.scrollY > bannerHeight) {
        if (headerBB.top > -5) {
            fixHeader();
        }
    } else if (!locked && header.classList.contains("fixed")) {
        header.style.top =
            window.scrollY < bannerHeight ? bannerHeight : window.scrollY;
        header.classList.remove("fixed");
    }

    lastScroll = window.scrollY;
});

document.querySelector(".more")?.addEventListener("click", e => {
    e.currentTarget.classList.toggle("show")
    e.currentTarget.nextElementSibling.classList.toggle("show")
})

document.querySelectorAll(".back-navigation").forEach((b) => {
    b.addEventListener("click", () => {
        if (
            window.history.length > 1 &&
            document.referrer.indexOf(window.location.host) !== -1
        ) {
            window.history.back();
            unlockBodyScroll();
        } else {
            window.location.href = Shopify.routes.root;
        }
    });
});

const blogNavMobile = document.querySelector(".blog > nav");
const trigger = document.querySelector(".blog-nav-mobile-trigger");

trigger?.addEventListener("click", (e) => {
    if (trigger.classList.contains("show")) {
        closeBlogNavMobile();
    } else {
        openBlogNavMobile();
    }
});

function openBlogNavMobile() {
    const triggerBB = trigger.getBoundingClientRect();
    trigger.classList.add("show");
    blogNavMobile.classList.add("show");
    blogNavMobile.style.height = `calc(100% - ${triggerBB.height}px)`;
    blogNavMobile.style.top = window.innerHeight;
    blogNavMobile.style.opacity = 0;
    setTimeout(() => {
        blogNavMobile.style.top = triggerBB.height;
        blogNavMobile.style.opacity = 1;
    });
}

function closeBlogNavMobile() {
    blogNavMobile.style.top = window.innerHeight;
    blogNavMobile.style.opacity = 0;
    setTimeout(() => {
        blogNavMobile.classList.remove("show");
        blogNavMobile.style.opacity = null;
        blogNavMobile.style.top = null;
    }, 350);
    trigger.classList.remove("show");
}


const blogNav = document.querySelector(".blog > nav");
blogNav?.querySelectorAll(":scope > div").forEach((e) => {
    e.addEventListener("click", (ee) => {
        if (window.innerWidth <= 910) {
            blogNav.querySelectorAll(":scope > .active").forEach((eee) =>
                eee.classList.remove("active"),
            );
            blogNav.querySelectorAll(".open").forEach((eee) =>
                eee.classList.remove("open"),
            );
        }

        ee.currentTarget.classList.toggle("active");
        ee.currentTarget.nextElementSibling.classList.toggle("open");
    });
});

const cart = document.querySelector(".cart");
const cartToggler = document.querySelector(".cart-toggler");

const currency = document
    .querySelector("main")
    ?.getAttribute("data-currency")
    ?.split("-");
const symbol = currency?.at(0);
const iso_code = currency?.at(1);

window.addEventListener("open-cart", () => {
    openCart();
});

cartToggler?.addEventListener("click", () => {
    if (cart.classList.contains("open")) {
        closeCart();
    } else {
        openCart();
    }
});

const url = new URL(window.location.href);
if (url.searchParams.get("cart") === "1") {
    openCart();
}

function openCart() {
    const e = new Event("open-drawer");
    e.elements = [cart, cartToggler];
    window.dispatchEvent(e);
    renderCart();
}

function closeCart() {
    const e = new Event("close-drawer");
    e.elements = [cart, cartToggler];
    window.dispatchEvent(e);
}

async function getCartItems() {
    const response = await fetch(window.Shopify.routes.root + "cart.js");
    const cart = await response.json();
    updateCartItemCount(cart.items);
    return cart.items;
}
getCartItems();

function updateCartItemCount(items) {
    const itemsCount = document.querySelector(".items-count");
    if(!itemsCount) return;
    itemsCount.innerText = items.reduce((tot, i) => tot + i.quantity, 0);
    if (items.length > 0) {
        itemsCount.classList.add("has-items");
    } else {
        itemsCount.classList.remove("has-items");
    }
}

async function renderCart() {
    const items = await getCartItems();
    const products = document.createElement("div");
    products.classList.add("products");

    if (items.length === 0) {
        cart.classList.add("empty");
    } else {
        cart.classList.remove("empty");

        const subtotal = cart.querySelector(".subtotal");
        const updateSubtotal = () => {
            let price =
                items.reduce((tot, i) => tot + i.price * i.quantity, 0) / 100;
            if (price) {
                price = `${iso_code} ${symbol}${price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
            }
            subtotal.innerText = price || "";
        };
        updateSubtotal();

        const productsList = document.createElement("ul");
        productsList.append(
            ...items.map((i) => renderCartProduct(i, updateSubtotal)),
        );
        products.append(productsList);
    }

    cart.querySelector(".products").replaceWith(products);
}

function renderCartProduct(variant, updateSubtotal) {
    const li = document.createElement("li");
    const item = document.createElement("a");
    item.href = variant.url;
    li.append(item);

    item.innerHTML = `
        <div>
            <img src="${variant.image}" />
        </div>`;

    const infos = document.createElement("div");
    infos.classList.add("infos");

    const [title, color] = variant.product_title.split(" - ");

    const options = variant.variant_title
        ? variant.options_with_values
              .map(
                  ({ name, value }) => `
                    <div>
                        <div>${name}</div>
                        <div>${value}</div>
                    </div>`,
              )
              .join("")
        : "&nbsp;";

    infos.innerHTML = `
        <div class="title">${title}</div>
        <div class="color-price">
            <div class="color">${color}</div>
            <div class="price"></div>
        </div>
        
        <div class="options">
            ${options}
        </div>
    `;

    const updateLinePrice = () => {
        let price = (variant.price * variant.quantity) / 100;
        if (price) {
            price = `${iso_code} ${symbol}${price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        }
        infos.querySelector(".price").innerText = price || "";
    };
    updateLinePrice();

    const quantity = document.createElement("div");
    quantity.classList.add("quantity");
    const remove = document.createElement("div");
    remove.classList.add("remove");
    remove.innerText = "-";
    remove.onclick = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (variant.quantity === 0) return;
        variant.quantity = variant.quantity - 1;
        if (variant.quantity === 0) {
            li.remove();
        } else {
            count.innerText = variant.quantity;
        }
        updateSubtotal();
        updateLinePrice();
        await fetch(window.Shopify.routes.root + "cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                id: variant.id.toString(),
                quantity: variant.quantity,
            }),
        });
        renderCart();
    };
    const count = document.createElement("div");
    count.classList.add("count");
    count.innerText = variant.quantity;
    const add = document.createElement("div");
    add.classList.add("add");
    add.innerText = "+";
    add.onclick = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        variant.quantity = variant.quantity + 1;
        count.innerText = variant.quantity;
        updateSubtotal();
        updateLinePrice();
        await fetch(window.Shopify.routes.root + "cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                id: variant.id.toString(),
                quantity: variant.quantity,
            }),
        });
        renderCart();
    };
    quantity.append(remove, count, add);
    infos.append(quantity);
    item.append(infos);

    return li;
}

const main = document.querySelector("main");
const imgs = main.querySelectorAll("img");
const fullscreenContainer = document.querySelector(".img-fullscreen");
const closeButton = fullscreenContainer?.querySelector(".close");

closeButton?.addEventListener("click", () => {
    closeImagesFullScreen();
});

window.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
        closeImagesFullScreen();
    }
});

imgs.forEach((img) => {
    let parent = img;
    while (parent) {
        if (parent?.classList?.contains("no-fullscreen")) {
            return;
        }
        parent = parent?.parentElement;
    }
    img.addEventListener("click", openImagesFullScreen);
});

function closeImagesFullScreen() {
    unlockBodyScroll();
    fullscreenContainer.classList.remove("show");
}

function openImagesFullScreen(e) {
    lockBodyScroll();
    const shownImages = Array.from(fullscreenContainer.children);

    fullscreenContainer.classList.add("show");

    imgs.forEach((img, i) => {
        let fullscreenImg = shownImages.find((i) => i.src === img.src);
        if (!fullscreenImg) {
            fullscreenImg = img.cloneNode();
            fullscreenContainer.append(fullscreenImg);
        }
        if (e.currentTarget === img) {
            setTimeout(() => {
                const fullscreenImgs = Array.from(
                    fullscreenContainer.querySelectorAll("img"),
                );

                const imgBB = fullscreenImgs.at(i).getBoundingClientRect();

                let x = 0,
                    y = 0;

                if (fullscreenContainer.scrollWidth > window.innerWidth) {
                    const left = fullscreenImgs
                        .slice(0, i)
                        .reduce((tot, img) => img.width + tot, 0);
                    x = left - window.innerWidth / 2 + imgBB.width / 2;
                }
                if (fullscreenContainer.scrollHeight > window.innerHeight) {
                    const top = fullscreenImgs
                        .slice(0, i)
                        .reduce((tot, img) => img.height + tot, 0);
                    y = top - window.innerHeight / 2 + imgBB.height / 2;
                }

                fullscreenContainer.scrollTo(x, y);
            });
        }
    });
}

function lockBodyScroll() {
    document.body.style.overflow = "hidden";
}
function unlockBodyScroll() {
    document.body.style.overflow = null;
}

const menuToggler = document.querySelector(".menu-mobile-toggler");
const menu = document.querySelector(".menu-mobile");

menuToggler?.addEventListener("click", () => {
    let event = "open-drawer";
    if (menu.classList.contains("open")) {
        event = "close-drawer";
        menuToggler.classList.remove("open");
        document.querySelector(".currency-switcher").classList.remove("show");
    } else {
        menuToggler.classList.add("open");
    }
    const e = new Event(event);
    e.elements = [menu, menuToggler];
    window.dispatchEvent(e);
});

document.querySelector(".currency-switcher")?.addEventListener("click", (e) => {
    e.currentTarget.classList.toggle("show");
});

const submenuTrigger = document.querySelectorAll(".has-submenu");
const submenuBackButtons = document.querySelectorAll(".back");

submenuTrigger.forEach((el) => el.addEventListener("click", toggleSubmenu));
submenuBackButtons.forEach((el) => el.addEventListener("click", submenuBack));

let submenus = [];

window.addEventListener("drawer-closed", () => {
    submenus.forEach(({ submenu, parent }) => {
        submenu.style.transform = null;
        parent?.append(submenu)
    });
    submenus = [];
    document.querySelector(".submenu-container")?.remove();
});

function toggleSubmenu(e) {
    let submenuContainer;

    if (window.innerWidth <= 768) {
        submenuContainer = document.querySelector(".menu-mobile");;

        if (submenus.length == 0) {
            submenus.push({ submenu: submenuContainer.children[0] });
        }
    } else {
        submenuContainer = document.querySelector(".submenu-container");
        if (!submenuContainer) {
            submenuContainer = document.createElement("div");
            submenuContainer.classList.add("submenu-container");
            document.body.append(submenuContainer);
            const d = new Event("open-drawer");
            d.elements = [submenuContainer, e.currentTarget];
            window.dispatchEvent(d);
        }
    }

    const submenu = e.currentTarget.nextElementSibling;

    if (!submenu) {
        const d = new Event("close-drawer");
        window.dispatchEvent(d);
        return;
    }

    if (submenus.length) {
        submenu.classList.add("has-back");
    }
    submenus.push({ submenu, parent: submenu.parentElement });
    submenuContainer.append(submenu);

    setTimeout(() => {
        submenus.forEach(
            ({ submenu }, i) =>
                (submenu.style.transform = `translateX(-${submenus.length - 1}00%)`),
        );
    }, 10);
}

function submenuBack() {
    submenus.forEach(
        ({ submenu }, i) =>
            (submenu.style.transform = `translateX(-${submenus.length - 2}00%)`),
    );
    setTimeout(() => {
        const last = submenus.pop();
        last.parent.append(last.submenu);
    }, 350);
}

const currencyDesktop = document.querySelector(".currency-desktop");

currencyDesktop?.addEventListener("click", (e) => {
    e.currentTarget.classList.add("open");
});

window.addEventListener("touchstart", () => {
    currencyDesktop?.classList.remove("open");
});
window.addEventListener("mousemove", () => {
    currencyDesktop?.classList.remove("open");
});

const accordion = document.querySelector(".product-accordion");
const accordionSections = accordion?.querySelectorAll(":scope > div");

accordionSections?.forEach((s) => {
    const title = s.querySelector(":scope > .title");
    title.addEventListener("click", () => {
        accordionSections.forEach((ss) => {
            if (ss !== s) {
                ss.querySelector(".content").style.maxHeight = null;
                ss.classList.remove("open");
            }
        });

        if (s.classList.contains("open")) {
            s.querySelector(".content").style.maxHeight = null;
            s.classList.remove("open");
        } else {
            s.classList.toggle("open");
            const content = s.querySelector(".content");
            const width = content.getBoundingClientRect().width;
            const clone = content.cloneNode(true);
            clone.style.transition = "none";
            clone.style.maxHeight = "unset";
            clone.style.width = "100%";
            clone.style.position = "absolute";
            clone.style.opacity = "0";
            content.parentElement.append(clone);

            let imagesLoaded = 0;
            const images = Array.from(clone.querySelectorAll("img"));

            const size = () => {
                if (imagesLoaded !== images.length) return;

                const height = clone.getBoundingClientRect().height;
                content.style.maxHeight = height;
                clone.remove();
            };

            if (images.length) {
                images.forEach((img) => {
                    onload = () => {
                        imagesLoaded++;
                        size();
                    };
                    img.onerror = onload;
                    if (img.complete) {
                        onload();
                    } else {
                        img.onload = onload;
                    }
                });
            } else {
                size();
            }
        }
    });
});

const viewFitGuide = document.querySelector(".view-fit-guide");
const viewFitGuideClose = document.querySelector(".view-fit-guide .close");
viewFitGuide?.addEventListener("click", (e) => {
    e.stopPropagation();
    lockBodyScroll();
    viewFitGuide.classList.add("show");
});

function closeFitGuide(e) {
    e?.stopPropagation();
    unlockBodyScroll();
    viewFitGuide?.classList.remove("show");
}

viewFitGuideClose?.addEventListener("click", closeFitGuide);
window.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
        closeFitGuide();
    }
});

const gridViewToggler = Array.from(
    document.querySelectorAll(".products-grid-toggler"),
);
const gridTogglers = gridViewToggler.map((toggler) =>
    Array.from(toggler.querySelectorAll("span")),
);

const gridTriggers = Array.from(
    document.querySelectorAll(".products-grid-toggler > div"),
);
const gridViews = [2, 4, 8];

gridTogglers.forEach((toggler) => {
    toggler.forEach((span, i) => {
        span.addEventListener("click", () => {
            setView(i);
        });
    });
});
gridTriggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
        currentViewIndex = (currentViewIndex + 1) % gridViews.length;
        setView(currentViewIndex);
    });
});

let currentViewIndex = null;
function setView(viewIndex, save = true) {
    if (
        typeof viewIndex !== "number" ||
        isNaN(viewIndex) ||
        viewIndex < 0 ||
        viewIndex > gridViews.length - 1
    ) {
        viewIndex = 2;
    }
    currentViewIndex = viewIndex;
    gridTogglers.flat().forEach((t) => t.classList.remove("active"));
    document.querySelectorAll(".products-grid").forEach((grid) => {
        gridViews.forEach((v) => grid.classList.remove("grid-" + v));
        grid.classList.add("grid-" + gridViews[viewIndex]);
    });
    gridTogglers.forEach((t) => t[viewIndex].classList.add("active"));
    if (save) {
        window.localStorage.setItem("grid-view", gridViews[viewIndex]);
    }
    window.dispatchEvent(new Event("view-shift"));
}

const savedView = parseInt(window.localStorage.getItem("grid-view"));
const viewIndex = gridViews.indexOf(savedView);
if (viewIndex !== -1) {
    setView(viewIndex);
}

function initProductsGridView() {
    let save = true;
    gridViewToggler.forEach((t) => {
        const defaultView = t.getAttribute("data-default-view");
        if (defaultView) {
            save = false;
            currentViewIndex = gridViews.indexOf(parseInt(defaultView));
        }
    });
    setView(currentViewIndex, save);
    document
        .querySelectorAll(".products-grid")
        .forEach((e) => e.classList.add("show"));
}

window.addEventListener("init-products-grid", () => initProductsGridView());
initProductsGridView();

function loadMiniGrid() {
    const miniGridToLoad = document.querySelectorAll(
        ".products-mini-grid-ajax",
    );
    miniGridToLoad.forEach(miniGridLoad);
}
loadMiniGrid();
window.addEventListener("load-mini-grid", loadMiniGrid);

const miniGridParser = new DOMParser();

function miniGridLoad(el) {
    const loaded = el.getAttribute("data-loaded");
    if (loaded) return;

    el.setAttribute("data-loaded", "1");

    const handlesAttr = el.getAttribute("data-handles") || "";
    const handles = Array.from(
        new Set(
            handlesAttr
                .split(",")
                .map((i) => i.trim())
                .filter(Boolean),
        ),
    );
    if (handles.length === 0) {
        return;
    }

    let count = parseInt(el.getAttribute("data-count"));
    if (!count || isNaN(count)) {
        count = null;
    }

    const url = new URL(window.Shopify.routes.root, window.location.href);
    url.pathname += "/pages/recent";
    url.searchParams.set("cache", "false");
    url.searchParams.set("ajax", "1");
    url.searchParams.set("type", Math.floor(Math.random() * 1000000));
    const urlStr = url + "&products=" + handles.join(",");
    fetch(urlStr)
        .then((res) => res.text())
        .then((htmlStr) => {
            const html = miniGridParser.parseFromString(htmlStr, "text/html");
            const products = html.querySelector(".products-mini-grid");

            if (!products) return;

            if (count) {
                products.querySelectorAll(":scope > a").forEach((e, i) => {
                    if (i >= count) {
                        e.remove();
                    }
                });
            }

            if (
                Array.from(products.querySelectorAll(":scope > a")).length === 0
            ) {
                return;
            }

            el.querySelector(".products").append(products);
            el.classList.add("has-products");
        });
}

const searchToggler = document.querySelector(".search-toggler");
const searchView = document.querySelector("#search");
const searchInput = searchView?.querySelector("input");
const resultsContainer = searchView?.querySelector(".results");

const searchUrl = new URL(window.location.href);
if (searchUrl.searchParams.get("search") === "1") {
    openSearch();
}

searchToggler?.addEventListener("click", () => {
    if (searchView.classList.contains("open")) {
        closeSearch();
    } else {
        openSearch();
    }
});

function openSearch() {
    const e = new Event("open-drawer");
    e.elements = [searchView, searchToggler];
    window.dispatchEvent(e);
}
function closeSearch() {
    searchInput.blur();
    window.dispatchEvent(new Event("close-drawer"));
}

searchInput.addEventListener("keyup", search);

let searchDebouncer = null;

function search() {
    if (searchDebouncer) {
        clearTimeout(searchDebouncer);
    }
    searchDebouncer = setTimeout(searchRequest, 300);
}

let searchFetchController = null;

function searchRequest() {
    resultsContainer.classList.add("searching");
    searchFetchController?.abort();

    searchFetchController = new AbortController();
    fetch(`${window.Shopify.routes.root}search?ajax=1&q=${searchInput.value}`, {
        signal: searchFetchController.signal,
    })
        .then((res) => res.text())
        .then(displaySearchResults);
}

const searchResultsParser = new DOMParser();

function displaySearchResults(htmlStr) {
    resultsContainer.classList.remove("no-results");
    resultsContainer.classList.remove("searching");
    const html = searchResultsParser.parseFromString(htmlStr, "text/html");
    const products = html.querySelector("#search-results > .products-grid");
    const website = html.querySelector("#search-results > .website");

    console.log(html, products, website);

    const productsSection = resultsContainer.querySelector(".products");
    if (products) {
        productsSection.classList.add("has-results");
        const productsResults =
            productsSection.querySelector(".products-results");
        productsResults.innerHTML = "";
        productsResults.append(products);
        window.dispatchEvent(new Event("init-products-grid"));
    } else {
        productsSection.classList.remove("has-results");
    }

    const websiteSection = resultsContainer.querySelector(".website");
    if (website) {
        websiteSection.classList.add("has-results");
        const websiteResults = websiteSection.querySelector(".website-results");
        websiteResults.innerHTML = "";
        websiteResults.append(website);
    } else {
        websiteSection.classList.remove("has-results");
    }

    if (!website && !products && searchInput.value.trim() != "") {
        resultsContainer.classList.add("no-results");
    }
}

function convertSizeChart(e) {
    if (e.target.classList.contains("active")) return;

    document.querySelectorAll(".size_chart_units > span").forEach((unit) => {
        unit.classList.remove("active");
    });

    e.target.classList.add("active");

    const multiplicator = e.target.innerText === "CM" ? 2.54 : 0.393701;

    document
        .querySelector("table.esc-size-guide--table")
        .querySelectorAll("td")
        .forEach((cell) => {
            const value = parseFloat(cell.innerText);
            let decimalsCount = 0;
            if (cell.innerText.includes("."))
                decimalsCount = cell.innerText.split(".").pop().length;
            cell.innerText = (value * multiplicator).toFixed(decimalsCount);
        });
}
window.onload = function () {
    let count = 0;
    const interval = setInterval(() => {
        count++;
        if (count === 20) {
            clearInterval(interval);
            return;
        }

        const table = document.querySelector("table.esc-size-guide--table");
        if (!table) return;

        document.querySelector(".size-chart-container").style.display = "block";

        document.querySelectorAll(".esc-size-guide--title").forEach((title) => {
            title.innerHTML = `
                Size Chart
                <svg xmlns="http://www.w3.org/2000/svg" height="10" viewBox="0 0 9.302 9.302">
                  <path d="M1020-2567.78h6.086v-6.069" transform="translate(1098.737 2545.892) rotate(-45)" fill="none" stroke="currentColor" stroke-width="1"/>
                </svg>`;

            const section = title.parentElement.parentElement.parentElement;
            title.addEventListener("click", () => {
                section.classList.toggle("open");
            });

            const viewMore = document.querySelector(".size_chart_view_more");
            if (viewMore) {
                title.insertAdjacentElement("afterend", viewMore);
                viewMore.style.display = "block";
            }
        });

        const cell = table.querySelector("th");
        if (cell) {
            cell.innerHTML = `<div class="size_chart_units">
      				<span onclick="convertSizeChart(event)" >CM</span> | <span onclick="convertSizeChart(event)" class="active">IN</span>
      			</div>`;
        }

        clearInterval(interval);
    }, 100);
};

const pageLinks = Array.from(
    document.querySelectorAll(".multi-page-links > div"),
);
const pages = [];
pageLinks.forEach((pageLink) =>
    pages.push(pageLink.innerText.toLowerCase().replace(/ /g, "-")),
);

function togglePages(pageLinkClicked) {
    pageLinks.forEach((pageLink) => {
        const pageHandle = pageLink.getAttribute("data-page");
        const page = document.querySelector(".page." + pageHandle);
        if (pageLinkClicked === pageLink) {
            pageLink.setAttribute("aria-selected", "true");
            page.style.display = "block";
        } else {
            pageLink.setAttribute("aria-selected", "false");
            page.style.display = "none";
        }
    });
}

const multiPageUrl = new URL(window.location.href);
const pageQuery = multiPageUrl.searchParams.get("page");
const activePageIndex =
    pageQuery && pages.includes(pageQuery) ? pages.indexOf(pageQuery) : 0;

togglePages(pageLinks.at(activePageIndex));

pageLinks.forEach((pageLink) => {
    pageLink.addEventListener("click", () => togglePages(pageLink));
});

const countdown = document.querySelector(".password > .countdown");

if (countdown) {
    function isValidDate(d) {
        return d instanceof Date && !isNaN(d);
    }

    const msInSecond = 1000;
    const msInMinute = 60 * msInSecond;
    const msInHour = 60 * msInMinute;
    function msToHoursMinutesSecondsString(ms) {
        const hours = Math.floor(ms / msInHour);
        const minutes = Math.floor((ms - hours * msInHour) / msInMinute);
        const seconds = Math.floor(
            (ms - hours * msInHour - minutes * msInMinute) / msInSecond,
        );

        let str = (hours < 10 ? "0" + hours : hours) + ":";
        str += (minutes < 10 ? "0" + minutes : minutes) + ":";
        str += seconds < 10 ? "0" + seconds : seconds;

        return str;
    }

    function startCountdown() {
        const date = new Date(countdown.getAttribute("data-ends"));
        if (!isValidDate(date)) return;

        const updateCountdown = () => {
            const delta = date.getTime() - Date.now();
            countdown.innerText = msToHoursMinutesSecondsString(delta);
        };

        setInterval(updateCountdown, 1000);
        updateCountdown();
    }

    startCountdown();
}

const addToCartButton = document.querySelector(".add-to-cart");
const selectors = Array.from(document.querySelectorAll(".selectors > select"));

addToCartButton?.addEventListener("click", () => addToCart());

async function addToCart() {
    addToCartButton.disabled = true;

    const item = {
        id: null,
        quantity: 1,
    };

    if (selectors.length === 1) {
        item.id = parseInt(selectors[0].value);
    } else {
        item.id = parseInt(addToCartButton.getAttribute("data-id"));
    }

    if (!item.id) {
        addToCartButton.disabled = false;
        return;
    }

    try {
        const response = await fetch(
            window.Shopify.routes.root + "cart/add.js",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    items: [item],
                }),
            },
        );
        window.dispatchEvent(new Event("open-cart"));
    } catch (e) {
        console.error(e);
    }

    addToCartButton.disabled = false;
}

const sticky1 = document.querySelector(".sticky-1");
const desc = document.querySelector(".description");
const sticky2 = document.querySelector(".sticky-2");
const sticky2BB = sticky2?.getBoundingClientRect();
const miniGrids = document.querySelector(".mini-grids");

if (sticky2BB) {
    if (sticky1 && desc) {
        console.log(sticky2BB.height);
        sticky1.style.marginBottom = sticky2BB.height;
        desc.style.marginTop = 0 - sticky2BB.height + 10;
    }

    if (miniGrids) {
        miniGrids.style.top = 200 + sticky2BB.height;
    }
}

function getAvailableVariants(variants, values) {
    for (let j = 0; j < values.length; j++) {
        if (!values[j]) {
            continue;
        }

        variants = variants.filter((v) => v[j] === values[j]);
    }

    return variants;
}

const variantEl = document.querySelector("#variants");
if (variantEl) {
    const variants = variantEl.innerText
        .split("#")
        .map((i) => i.split(":").map((v) => v.replace(/"/g, "")));
    const optionsCount = selectors.length;
    selectors.forEach((select, i) => {
        select.addEventListener("change", (e) => {
            const availableVariants = getAvailableVariants(
                [...variants],
                Array.from(selectors).map((s) => s.value),
            );

            if (
                availableVariants.length === 1 &&
                availableVariants.at(0).at(-1) === "1"
            ) {
                addToCartButton.setAttribute(
                    "data-id",
                    availableVariants.at(0).at(-2),
                );
            } else {
                addToCartButton.removeAttribute("data-id");
            }

            selectors.forEach((s, j) => {
                const values = Array.from(selectors).map((s) => s.value);
                values[j] = "";
                const availableVariants = getAvailableVariants(
                    [...variants],
                    values,
                );
                console.log(j, availableVariants)

                s.querySelectorAll("option").forEach((o) => {
                    if (!o.value) return;
                    const available = availableVariants.find(
                        (v) => v[j] === o.value && v.at(-1) === "1",
                    );
                    if (available) {
                        o.disabled = false;
                        o.innerText = o.innerText
                            .replace(/\(Out of stock\)/g, "")
                            .trim();
                    } else {
                        o.disabled = true;
                        if (!o.innerText.includes("(Out of stock)")) {
                            o.innerText += " (Out of stock)";
                        }
                    }
                });
            });
        });
    });
}
